import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/depreciation-calculator',
  component: () => import('../../routes/DepreciationCalculator.svelte'),
  card: {
    id: 'depreciation-calculator',
    title: 'Depreciation Calculator',
    description: 'Calculate straight-line depreciation and view year-by-year schedules for any asset.',
    icon: 'trending_down',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/depreciation-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Depreciation Calculator – Straight-Line Depreciation Schedule',
    description:
      'Free depreciation calculator to calculate straight-line depreciation expense and generate year-by-year depreciation schedules for any asset based on original cost, salvage value, and useful life.',
  },
};

export default meta;
